import { fetchWrapper } from 'app/_helpers/fetch-wrapper';
import AjexPortalService from 'axios.js'
const WMSInbondURL = process.env.REACT_APP_API_WMSINBOUND_URL;
const loginURL = process.env.REACT_APP_API_AUTHENTICATION_URL;
const baseUrl = `${WMSInbondURL}user/`;

export const UserService = {
    getAll,
    getAllWithoutUserFilter,
    getById,
    create,
    update,
    getuserByusername,

    AuthServerRegister,
    delete: _delete
};

function getAll() {
    return fetchWrapper.get(baseUrl);
}
function getAllWithoutUserFilter() {
    return fetchWrapper.get(baseUrl + '/get-all');
}
async function AuthServerRegister(formData) {
    //delete AjexPortalService.defaults.headers.common.Authorization
    const response = await AjexPortalService.post(loginURL + 'signup', formData)

    return response;
}
function getById(id) {
    return fetchWrapper.get(`${baseUrl}/${id}`);
}
function getuserByusername(id) {

    return fetchWrapper.get(`${baseUrl}/user-name?userName=${id}`);

}
function create(params) {
    return fetchWrapper.post(baseUrl, params);
}

function update(id, params) {

    return fetchWrapper.put(`${baseUrl}${id}`, params);
    //return fetchWrapper.put(`${baseUrl}`, params);

}

// prefixed with underscored because delete is a reserved word in javascript
function _delete(id) {
    return fetchWrapper.delete(`${baseUrl}/${id}`);
}